import React from "react";
import { connect } from "react-redux";
import AddIcon from "../UIComponents/AddIcon";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import axios from "axios";
import API from "../helpers/api";
import { showLoader } from "../Actions/PageLoaderAPI";
import { Card } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import { DownloadDocument, Uploadec, Uploadldafd, Uploadamp, UploadIAPP } from "../Actions/CommonAPI";
import { getCertificates } from "../Actions/ShipViewAPI";
import $ from "jquery";
import { toast } from "react-toastify";
import { NavItem } from "reactstrap";
import Role from "../helpers/role";

let user = JSON.parse(localStorage.getItem("currentUser"));
var today = new Date();
var currentDate = Moment(new Date(Date.parse(today))).format(
    "YYYY-MM-DD"
)
let userrole = localStorage.getItem("UserRoles");

class Certificates extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            iappfile: '',
            ecfile: '',
            ldafdfile: '',
            ampfile: '',
            iappFilename: '',
            ecFilename: '',
            ldafdFilename: '',
            ampFilename: '',
            iappFromDateOpen: false,
            iappToDateOpen: false,
            ecFromDateOpen: false,
            ecToDateOpen: false,
            ldafdFromDateOpen: false,
            isActive: false,
            loaded: true,
            shipData: {
                iappAttachmentName: "",
                iappAttachmentGuid: "",
                ecAttachmentName: "",
                ecAttachmentGuid: "",
                ldafdAttachmentName: "",
                ldafdAttachmentGuid: "",
                ampAttachmentName: "",
                ampAttachmentGuid: "",
                iappIssuedDate: "",
                iappExpiryDate: "",
                ecIssuedDate: "",
                ecExpiryDate: "",
                ldafdIssuedDate: "",
                shipUsers: [],
                attachmentName: '',
                attachmentGuid: '',
                createdBy: user.email
            },
            createdBy: user.email,
        };
        this.handleBlur = this.handleBlur.bind(this);
        this.handleiappFromDateChange = this.handleiappFromDateChange.bind(this);
        this.handleiappToDateChange = this.handleiappToDateChange.bind(this);
        this.handleecFromDateChange = this.handleecFromDateChange.bind(this);
        this.handleecToDateChange = this.handleecToDateChange.bind(this);
        this.handleldafdFromDateChange = this.handleldafdFromDateChange.bind(this);

    }


    componentDidMount() {
        // const { dispatch, match } = this.props;
        // const { params } = match;
        // const { id } = params;
        // dispatch(getCertificateHKC(id));
        // dispatch(getCertificateEUSRR(id));
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, IAPPAttachment, AMPAttachment, ECAttachment, LDSFAAttachment } = nextProps;
        console.log(IAPPAttachment);
        if (ECAttachment && ECAttachment !== "") {
            prevState.shipData.ecAttachmentName = ECAttachment.FileName;
            prevState.shipData.ecAttachmentGuid = ECAttachment.Guid;
            dispatch({ type: "AttachmentUploadecSuccess", data: "" })
            ECAttachment.length = 0;
        }
        if (LDSFAAttachment && LDSFAAttachment !== "") {
            prevState.shipData.ldafdAttachmentName = LDSFAAttachment.FileName;
            prevState.shipData.ldafdAttachmentGuid = LDSFAAttachment.Guid;
            dispatch({ type: "AttachmentUploadldafdSuccess", data: "" })
            LDSFAAttachment.length = 0;
        }
        if (AMPAttachment && AMPAttachment !== "") {
            prevState.shipData.ampAttachmentName = AMPAttachment.FileName;
            prevState.shipData.ampAttachmentGuid = AMPAttachment.Guid;
            dispatch({ type: "AttachmentUploadampSuccess", data: "" })
            AMPAttachment.length = 0;
        }
        if (IAPPAttachment && IAPPAttachment !== "") {
            prevState.shipData.iappAttachmentName = IAPPAttachment.FileName;
            prevState.shipData.iappAttachmentGuid = IAPPAttachment.Guid;
            dispatch({ type: "AttachmentUploadIAPPSuccess", data: "" });
            IAPPAttachment.length = 0;
        }
        if (prevState.iappfile !== "") {
            dispatch(UploadIAPP(prevState.iappfile));
            prevState.iappfile = "";
        }
        if (prevState.ecfile !== "") {
            dispatch(Uploadec(prevState.ecfile));
            prevState.ecfile = "";
        }
        if (prevState.ldafdfile !== "") {
            dispatch(Uploadldafd(prevState.ldafdfile));
            prevState.ldafdfile = "";
        }
        if (prevState.ampfile !== "") {
            dispatch(Uploadamp(prevState.ampfile));
            prevState.ampfile = "";
        }

    }

    handleiappFromDateChange = (date) => {
        this.state.shipData.iappIssuedDate = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            iappFromDateOpen: false,
        });
    }

    handleiappToDateChange = (date) => {
        if (Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >= this.state.shipData.iappIssuedDate) {
            this.state.shipData.iappExpiryDate = Moment(new Date(Date.parse(date))).format(
                "YYYY-MM-DD"
            );
        } else {
            //  swal('Error!', 'To date must greater than from date ', 'warning');
        }
        this.setState({
            iappToDateOpen: false,
        });
    }

    handleecFromDateChange = (date) => {
        this.state.shipData.ecIssuedDate = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            ecFromDateOpen: false,
        });
    }

    handleecToDateChange = (date) => {
        if (Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >= this.state.shipData.ecIssuedDate) {
            this.state.shipData.ecExpiryDate = Moment(new Date(Date.parse(date))).format(
                "YYYY-MM-DD"
            );
        } else {
            //  swal('Error!', 'To date must greater than from date ', 'warning');
        }
        this.setState({
            ecToDateOpen: false,
        });
    }

    handleldafdFromDateChange = (date) => {
        this.state.shipData.ldafdIssuedDate = Moment(new Date(Date.parse(date))).format(
            "YYYY-MM-DD"
        );
        this.setState({
            ldafdFromDateOpen: false,
        });
    }

    Clearamp = () => {
        const { dispatch } = this.props;
        this.setState({
            ampFilename: '',
            ampfile: '',
        });
    }

    Clearec = () => {
        const { dispatch } = this.props;
        this.setState({
            ecFilename: '',
            ecfile: '',
            shipData: {
                ecIssuedDate: "",
                ecExpiryDate: ""
            }
        });
    }

    Clearldafd = () => {
        const { dispatch } = this.props;
        this.setState({
            ldafdFilename: '',
            ldafdfile: '',
            shipData: {
                ldafdIssuedDate: "",
            }
        });
    }

    ClearIAPP = () => {
        const { dispatch } = this.props;
        this.setState({
            iappFilename: '',
            iappfile: '',
            shipData: {
                iappIssuedDate: "",
                iappExpiryDate: "",
            }
        });
    }

    openiappFromDatePicker = () => {
        this.setState({
            ldafdFromDateOpen: false,
            ecFromDateOpen: false,
            ecToDateOpen: false,
            iappToDateOpen: false,
            iappFromDateOpen: !this.state.iappFromDateOpen,
        });
    }

    openiappToDatePicker = () => {
        this.setState({
            ldafdFromDateOpen: false,
            ecFromDateOpen: false,
            ecToDateOpen: false,
            iappFromDateOpen: false,
            iappToDateOpen: !this.state.iappToDateOpen
        });
    }

    openecFromDatePicker = () => {
        this.setState({
            iappFromDateOpen: false,
            iappToDateOpen: false,
            ldafdFromDateOpen: false,
            ecToDateOpen: false,
            ecFromDateOpen: !this.state.ecFromDateOpen,
        });
    }

    openecToDatePicker = () => {
        this.setState({
            iappFromDateOpen: false,
            iappToDateOpen: false,
            ldafdFromDateOpen: false,
            ecFromDateOpen: false,
            ecToDateOpen: !this.state.ecToDateOpen
        });
    }

    openldafdFromDatePicker = () => {
        this.setState({
            iappFromDateOpen: false,
            iappToDateOpen: false,
            ecFromDateOpen: false,
            ecToDateOpen: false,
            ldafdFromDateOpen: !this.state.ldafdFromDateOpen
        });
    }

    handleBlur = () => {
        this.setState({
            ldafdFromDateOpen: false,
            ecFromDateOpen: false,
            ecToDateOpen: false,
            iappFromDateOpen: false,
            iappToDateOpen: false
        });
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        if (nodeName === "IAPP") {
            this.state.iappFilename = e.target.files[0].name;
            this.state.iappfile = e.target.files[0];
            this.setState({});
        } else if (nodeName === "ec") {
            this.state.ecFilename = e.target.files[0].name;
            this.state.ecfile = e.target.files[0];
            this.setState({});
        } else if (nodeName === "ldafd") {
            this.state.ldafdFilename = e.target.files[0].name;
            this.state.ldafdfile = e.target.files[0];
            this.setState({});
        } else if (nodeName === "amp") {
            this.state.ampFilename = e.target.files[0].name;
            this.state.ampfile = e.target.files[0];
            this.setState({});
        }
    }

    downloadDocument(attachmentDetail) {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(attachmentDetail.attachmentName, attachmentDetail.attachmentGuid));
    }

    updateIAPP() {
        const { dispatch, CertificateHKC } = this.props;
        let data1 = {
            shipId: CertificateHKC.shipId,
            certificates: [
                {
                    certificateType: "iapp",
                    certificateId: CertificateHKC.certificates.filter(x => x.certificateType == "iapp")[0].certificateId,
                    issuedBy: CertificateHKC.certificates.filter(x => x.certificateType == "iapp")[0].issuedBy,
                    issuedDate: this.state.shipData.iappIssuedDate,
                    expiryDate: this.state.shipData.iappExpiryDate,
                    attachmentName: this.state.shipData.iappAttachmentName,
                    attachmentGuid: this.state.shipData.iappAttachmentGuid,
                },
            ],
            createdBy: user.email,

        }
        let url1 = `${API.Certificates}`;
        axios.post(url1, data1)
            .then((res) => {
                toast.success("IAPP Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                dispatch({
                    type: "postCertificateSuccess",
                    data: res.data,
                });

                this.ClearIAPP();
                $("#IAPP").modal("hide");
                dispatch(getCertificates(CertificateHKC.shipId));
            })
            .catch((error) => {
                dispatch({
                    type: "postCertificateFailure",
                    error: "ERROR"
                })

                this.ClearIAPP();
                $("#IAPP").modal("hide");
            })
    }

    updateEC() {
        const { dispatch, CertificateHKC } = this.props;
        let data1 = {
            certificates: [
                {
                    certificateType: "exemptioncertificate",
                    certificateId: CertificateHKC.certificates.filter(x => x.certificateType == "exemptioncertificate")[0].certificateId,
                    issuedDate: this.state.shipData.ecIssuedDate,
                    expiryDate: this.state.shipData.ecExpiryDate,
                    attachmentName: this.state.shipData.ecAttachmentName,
                    attachmentGuid: this.state.shipData.ecAttachmentGuid
                }
            ],
            createdBy: user.email,
            shipId: CertificateHKC.shipId
        }
        let url1 = `${API.Certificates}`;
        axios.post(url1, data1)
            .then((res) => {
                toast.success("Exemption Certificate Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                dispatch({
                    type: "postCertificateSuccess",
                    data: res.data,
                })

                this.Clearec();
                $("#ExemptionCertificate").modal("hide");
                dispatch(getCertificates(CertificateHKC.shipId));
            })
            .catch((error) => {
                dispatch({
                    type: "postCertificateFailure",
                    error: "ERROR"
                })

                this.Clearec();
                $("#ExemptionCertificate").modal("hide");
            })

    }

    updateldafd() {
        const { dispatch, CertificateHKC } = this.props;
        let data1 = {
            certificates: [
                {
                    certificateType: "asbestosfreedeclaration",
                    certificateId: CertificateHKC.certificates.filter(x => x.certificateType == "asbestosfreedeclaration")[0].certificateId,
                    issuedDate: this.state.shipData.ldafdIssuedDate,
                    expiryDate: null,
                    attachmentName: this.state.shipData.ldafdAttachmentName,
                    attachmentGuid: this.state.shipData.ldafdAttachmentGuid
                }
            ],
            createdBy: user.email,
            shipId: CertificateHKC.shipId
        }
        let url1 = `${API.Certificates}`;
        axios.post(url1, data1)
            .then((res) => {
                toast.success("Asbestos Free Declaration Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                dispatch({
                    type: "postCertificateSuccess",
                    data: res.data,
                })

                this.Clearldafd();
                $("#LastDrydockAsbestosFreeDeclaration").modal("hide");
                dispatch(getCertificates(CertificateHKC.shipId));
            })
            .catch((error) => {
                dispatch({
                    type: "postCertificateFailure",
                    error: "ERROR"
                })

                this.Clearldafd();
                $("#LastDrydockAsbestosFreeDeclaration").modal("hide");
            })
    }

    updateAmp() {
        const { dispatch, CertificateHKC } = this.props;
        let data1 = {
            certificates: [
                {
                    certificateType: "asbestosplan",
                    certificateId: CertificateHKC.certificates.filter(x => x.certificateType == "asbestosplan")[0].certificateId,
                    issuedDate: null,
                    expiryDate: null,
                    attachmentName: this.state.shipData.ampAttachmentName,
                    attachmentGuid: this.state.shipData.ampAttachmentGuid
                }
            ],
            createdBy: user.email,
            shipId: CertificateHKC.shipId
        }
        let url1 = `${API.Certificates}`;
        axios.post(url1, data1)
            .then((res) => {
                toast.success("Asbestos Plan Updated Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                dispatch({
                    type: "postCertificateSuccess",
                    data: res.data,
                })

                this.Clearamp();
                $("#AsbestosManagementPlan").modal("hide");
                dispatch(getCertificates(CertificateHKC.shipId));
            })
            .catch((error) => {
                dispatch({
                    type: "postCertificateFailure",
                    error: "ERROR"
                })

                this.Clearamp();
                $("#AsbestosManagementPlan").modal("hide");
            })
    }

    toggleVisibility = () =>
        this.setState(prevState => ({ isActive: !this.state.isActive }));

    render() {
        const { CertificateHKC } = this.props;
        console.log(CertificateHKC);
        return (
            <>
                {CertificateHKC && CertificateHKC.certificates && CertificateHKC.certificates.map((item) => {
                    return (
                        <>
                            {item.certificateType === "hkc" &&
                                <div className="full-heightpb-4">
                                    <div className="row mt-3">
                                        <div className="col-lg-12">
                                            <div className="panel-box">
                                                <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                    <div className="card-body flex">
                                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                        Certificate/SOC HKC
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div className="py-3">
                                                    <div className="resource-list-auth-date">
                                                        <div className="row">
                                                            <div className={"col-sm-12"}>
                                                                <div className="row mx-2 my-2">
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Issued Date : </strong>
                                                                            <span className="lato">
                                                                                {item.issuedDate ? Moment(new Date(Date.parse(item.issuedDate))).format('DD MMM YYYY') : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Expiry Date : </strong>
                                                                            <span className="lato">
                                                                                {item.expiryDate ? Moment(new Date(Date.parse(item.expiryDate))).format('DD MMM YYYY') : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Issued By : </strong>
                                                                            <span className="lato">
                                                                                {item.issuedBy ? item.issuedBy : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Download : </strong>
                                                                            <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                {item.attachmentName && item.attachmentName ?
                                                                                <>
                                                                                    <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                    <a href={item?.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                    <i class="fa fa-eye click ml-1"></i>
                                                                                    </a>
                                                                                 </>
                                                                                    : null}</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            }
                            {item.certificateType === "eussr" &&
                                <div className="full-heightpb-4">
                                    <div className="row mt-3">
                                        <div className="col-lg-12">
                                            <div className="panel-box">
                                                <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                    <div className="card-body flex">
                                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                        Certificate/SOC EUSRR
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div className="py-3">
                                                    <div className="resource-list-auth-date">
                                                        <div className="row">
                                                            <div className={"col-sm-12"}>
                                                                <div className="row mx-2 my-2">
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Issued Date : </strong>
                                                                            <span className="lato">
                                                                                {item.issuedDate ? Moment(new Date(Date.parse(item.issuedDate))).format('DD MMM YYYY') : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Expiry Date : </strong>
                                                                            <span className="lato">
                                                                                {item.expiryDate ? Moment(new Date(Date.parse(item.expiryDate))).format('DD MMM YYYY') : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Issued By : </strong>
                                                                            <span className="lato">
                                                                                {item.issuedBy ? item.issuedBy : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Download : </strong>
                                                                            <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                {item.attachmentName && item.attachmentName ?
                                                                                <>
                                                                                    <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                    <a href={item?.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                    <i class="fa fa-eye click ml-1"></i>
                                                                                    </a>
                                                                                 </>
                                                                                    : null}</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {item.certificateType === "flagsoc" &&
                                <div className="full-heightpb-4">
                                    <div className="row mt-3">
                                        <div className="col-lg-12">
                                            <div className="panel-box">
                                                <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                    <div className="card-body flex">
                                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                            Certificate Flag SOC
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div className="py-3">
                                                    <div className="resource-list-auth-date">
                                                        <div className="row">
                                                            <div className={"col-sm-12"}>
                                                                <div className="row mx-2 my-2">
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Issued Date : </strong>
                                                                            <span className="lato">
                                                                                {item.issuedDate ? Moment(new Date(Date.parse(item.issuedDate))).format('DD MMM YYYY') : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Expiry Date : </strong>
                                                                            <span className="lato">
                                                                                {item.expiryDate ? Moment(new Date(Date.parse(item.expiryDate))).format('DD MMM YYYY') : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Issued By : </strong>
                                                                            <span className="lato">
                                                                                {item.issuedBy ? item.issuedBy : ""}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-sm-3">
                                                                        <span>
                                                                            <strong>Download : </strong>
                                                                            <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                {item.attachmentName && item.attachmentName ?
                                                                                <>
                                                                                    <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                    <a href={item?.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                    <i class="fa fa-eye click ml-1"></i>
                                                                                      </a>
                                                                                   </>
                                                                                    : null}</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </>
                    )
                })
                }
                <div className="row mt-3">
                    <div className="col-lg-12">
                        <div className="panel-box">
                            <Accordion>
                                <Card className={"MM-card-header"} style={{ backgroundColor: "#f0f0f0" }}>
                                    <Accordion.Toggle as={Card.Body} eventKey="0" style={{ cursor: "pointer" }} onClick={this.toggleVisibility}>
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {!this.state.isActive ? <i className="fa fa-plus mr-1" aria-hidden="true" style={{ color: "#fff", fontSize: '1.1rem' }}></i> : <i className="fa fa-minus mr-1" aria-hidden="true" style={{ color: "#fff", fontSize: '1.1rem' }}></i>} IHM Related Documents
                                        </h5>
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                        <>
                                            {CertificateHKC && CertificateHKC.certificates && CertificateHKC.certificates.map((item) => {
                                                return(
                                                <>
                                                {
                                                    item.certificateType === "iapp" && <div className={`full-heightpb-4`}>
                                                        <div className="row mt-3">
                                                            <div className="col-lg-12">
                                                                <div className="panel-box">
                                                                    <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                                        <div className="card-body flex">
                                                                            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                                                Certificate IAPP (Applicable only if ODS is identified in IHM Part 1)
                                                                            </h5>
                                                                            {userrole === Role.staff ?
                                                                                <div className="m-1 flex" onClick={this.NewitemNav} data-toggle="modal" data-target="#IAPP">
                                                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="py-3">
                                                                        <div className="resource-list-auth-date">
                                                                            <div className="row">
                                                                                <div className={"col-sm-12"}>
                                                                                    <div className="row mx-2 my-2">
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Issued Date : </strong>
                                                                                                <span className="lato">
                                                                                                    {item.issuedDate ? Moment(new Date(Date.parse(item.issuedDate))).format('DD MMM YYYY') : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Expiry Date : </strong>
                                                                                                <span className="lato">
                                                                                                    {item.expiryDate ? Moment(new Date(Date.parse(item.expiryDate))).format('DD MMM YYYY') : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Issued By : </strong>
                                                                                                <span className="lato">
                                                                                                    {item.issuedBy ? item.issuedBy : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Download : </strong>
                                                                                                <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                                    {item.attachmentName && item.attachmentName ?
                                                                                                    <>
                                                                                                        <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                                        <a href={item?.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                                        <i class="fa fa-eye click ml-1"></i>
                                                                                                        </a>
                                                                                                     </>
                                                                                                        : null}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal fade bd-example-modal-lg" id="IAPP" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header" style={{ backgroundColor: "#1E3A8A" }}>
                                                                        <h5 className="modal-title" id="exampleModalLabel" style={{ color: "white" }}>Certificate IAPP</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <div className="col-lg-12 m-1">
                                                                            <label className="form-label">IAPP </label><br></br>
                                                                            <div class="input-group">
                                                                                <div class="input-group-prepend">
                                                                                    <span class="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="IAPP"
                                                                                        onChange={e => this.handleInputChange(e)}
                                                                                        onClick={(event) => { event.currentTarget.value = null }}

                                                                                    />
                                                                                    </span>
                                                                                </div>
                                                                                <input type="text" class="form-control" placeholder="No file chosen"
                                                                                    value={this.state.iappFilename}

                                                                                />
                                                                                {this.state.iappFilename !== "" ?
                                                                                    <div class="input-group-append" style={{ cursor: "pointer" }}>
                                                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.ClearIAPP()}></i>
                                                                                    </div>
                                                                                    : null}
                                                                            </div>
                                                                        </div>
                                                                        <div className="row m-2">
                                                                            <div className="col-lg-6">
                                                                                <label className="form-label">IAPP Issued Date</label>
                                                                                <div
                                                                                    className="input-group add-on date datepicker"
                                                                                    data-date-format="yyyy-mm-dd"  >
                                                                                    <input
                                                                                        type="text"
                                                                                        value={this.state.shipData.iappIssuedDate}
                                                                                        className="form-control date-picker"
                                                                                        placeholder="Issued Date"
                                                                                        name="POFromDate" ></input>
                                                                                    <DatePicker
                                                                                        onChange={this.handleiappFromDateChange}
                                                                                        open={this.state.iappFromDateOpen}
                                                                                        onClickOutside={this.handleBlur}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        popperPlacement="top-end"
                                                                                        className="form-control date-picker w-5 hide-date" />
                                                                                    <div
                                                                                        className="input-group-btn calendar-icon"
                                                                                        onClick={this.openiappFromDatePicker}
                                                                                    >
                                                                                        <button className="btn btn-default" style={{ height: "100%" }}>
                                                                                            <i className="fa fa-calendar mt-1"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                                <label className="form-label">IAPP Expiry Date</label>
                                                                                <div
                                                                                    className="input-group add-on date datepicker"
                                                                                    data-date-format="yyyy-mm-dd" >
                                                                                    <input
                                                                                        value={this.state.shipData.iappExpiryDate}
                                                                                        type="text"
                                                                                        placeholder="Expiry Date"
                                                                                        className="form-control date-picker"
                                                                                        name="POToDate"
                                                                                        data-date-format="yyyy-mm-dd"
                                                                                    />
                                                                                    <DatePicker
                                                                                        onChange={this.handleiappToDateChange}
                                                                                        open={this.state.iappToDateOpen}
                                                                                        onClickOutside={this.handleBlur}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        popperPlacement="top-end"
                                                                                        className="form-control date-picker w-5 hide-date"
                                                                                    />
                                                                                    <div className="input-group-btn calendar-icon">
                                                                                        <button
                                                                                            className="btn btn-default"
                                                                                            onClick={this.openiappToDatePicker}
                                                                                            style={{ height: "100%" }}
                                                                                        >
                                                                                            <i className="fa fa-calendar mt-1"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3" style={{ backgroundColor: "1E3A8A" }} onClick={() => this.updateIAPP()}>Update</button>
                                                                        <button type="button" className="btn btn-light text-uppercase txtside-btn txtht-btn mt-3" data-dismiss="modal">Cancel</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.certificateType === "exemptioncertificate" && <div className={`full-heightpb-4`}>
                                                        <div className="row mt-3">
                                                            <div className="col-lg-12">
                                                                <div className="panel-box">
                                                                    <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                                        <div className="card-body flex">
                                                                            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                                                Exemption Certificate (Applicable if Flag State has issued an exemption for Asbestos)
                                                                            </h5>
                                                                            {userrole === Role.staff ?
                                                                                <div className="m-1 flex" onClick={this.NewitemNav} data-toggle="modal" data-target="#ExemptionCertificate">
                                                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="py-3">
                                                                        <div className="resource-list-auth-date">
                                                                            <div className="row">
                                                                                <div className={"col-sm-12"}>
                                                                                    <div className="row mx-2 my-2">
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Issue Date : </strong>
                                                                                                <span className="lato">
                                                                                                    {item.issuedDate ? Moment(new Date(Date.parse(item.issuedDate))).format('DD MMM YYYY') : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Valid Till : </strong>
                                                                                                <span className="lato">
                                                                                                    {item.expiryDate ? Moment(new Date(Date.parse(item.expiryDate))).format('DD MMM YYYY') : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Download : </strong>
                                                                                                <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                                    {item.attachmentName && item.attachmentName ?
                                                                                                    <>
                                                                                                        <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                                        <a href={item?.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                                        <i class="fa fa-eye click ml-1"></i>
                                                                                                        </a>
                                                                                                     </>
                                                                                                        : null}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal fade bd-example-modal-lg" id="ExemptionCertificate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header" style={{ backgroundColor: "#1E3A8A" }}>
                                                                        <h5 className="modal-title" id="exampleModalLabel" style={{ color: "white" }}>Exemption Certificate</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }}>
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <div className="col-lg-12 m-1">
                                                                            <label className="form-label">Exemption Certificate</label><br></br>
                                                                            <div class="input-group">
                                                                                <div class="input-group-prepend">
                                                                                    <span class="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="ec"
                                                                                        onChange={e => this.handleInputChange(e)}
                                                                                        onClick={(event) => { event.currentTarget.value = null }}

                                                                                    />
                                                                                    </span>
                                                                                </div>
                                                                                <input type="text" class="form-control" placeholder="No file chosen"
                                                                                    value={this.state.ecFilename}
                                                                                />
                                                                                {this.state.ecFilename !== "" ?
                                                                                    <div class="input-group-append" style={{ cursor: "pointer" }}>
                                                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.Clearec()}></i>
                                                                                    </div>
                                                                                    : null}
                                                                            </div>
                                                                        </div>
                                                                        <div className="row m-2">
                                                                            <div className="col-lg-6">
                                                                                <label className="form-label">EC Issued Date</label>
                                                                                <div
                                                                                    className="input-group add-on date datepicker"
                                                                                    data-date-format="yyyy-mm-dd"  >
                                                                                    <input
                                                                                        type="text"
                                                                                        value={this.state.shipData.ecIssuedDate}
                                                                                        className="form-control date-picker"
                                                                                        placeholder="Issued Date"
                                                                                        name="POFromDate" ></input>
                                                                                    <DatePicker
                                                                                        onChange={this.handleecFromDateChange}
                                                                                        open={this.state.ecFromDateOpen}
                                                                                        onClickOutside={this.handleBlur}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        popperPlacement="top-end"
                                                                                        className="form-control date-picker w-5 hide-date" />
                                                                                    <div
                                                                                        className="input-group-btn calendar-icon"
                                                                                        onClick={this.openecFromDatePicker}
                                                                                    >
                                                                                        <button className="btn btn-default" style={{ height: "100%" }}>
                                                                                            <i className="fa fa-calendar mt-1"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                                <label className="form-label">EC Valid Till</label>
                                                                                <div
                                                                                    className="input-group add-on date datepicker"
                                                                                    data-date-format="yyyy-mm-dd" >
                                                                                    <input
                                                                                        value={this.state.shipData.ecExpiryDate}
                                                                                        type="text"
                                                                                        placeholder="Valid Till"
                                                                                        className="form-control date-picker"
                                                                                        name="POToDate"
                                                                                        data-date-format="yyyy-mm-dd"
                                                                                    />
                                                                                    <DatePicker
                                                                                        onChange={this.handleecToDateChange}
                                                                                        open={this.state.ecToDateOpen}
                                                                                        onClickOutside={this.handleBlur}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        popperPlacement="top-end"
                                                                                        className="form-control date-picker w-5 hide-date"
                                                                                    />
                                                                                    <div className="input-group-btn calendar-icon">
                                                                                        <button
                                                                                            className="btn btn-default"
                                                                                            onClick={this.openecToDatePicker}
                                                                                            style={{ height: "100%" }}
                                                                                        >
                                                                                            <i className="fa fa-calendar mt-1"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3" style={{ backgroundColor: "1E3A8A" }} onClick={() => this.updateEC()}>Update</button>
                                                                        <button type="button" className="btn btn-light text-uppercase txtside-btn txtht-btn mt-3" data-dismiss="modal">Cancel</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.certificateType === "asbestosfreedeclaration" && <div className={`full-heightpb-4`}>
                                                        <div className="row mt-3">
                                                            <div className="col-lg-12">
                                                                <div className="panel-box">
                                                                    <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                                        <div className="card-body flex">
                                                                            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                                                Last Drydock Asbestos Free Declaration (Vessel to upload last drydock asbestos free declaration from yard whenever available)
                                                                            </h5>
                                                                            {userrole === Role.staff ?
                                                                                <div className="m-1 flex" onClick={this.NewitemNav} data-toggle="modal" data-target="#LastDrydockAsbestosFreeDeclaration">
                                                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="py-3">
                                                                        <div className="resource-list-auth-date">
                                                                            <div className="row">
                                                                                <div className={"col-sm-12"}>
                                                                                    <div className="row mx-2 my-2">
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Issued On : </strong>
                                                                                                <span className="lato">
                                                                                                    {item.issuedDate ? Moment(new Date(Date.parse(item.issuedDate))).format('DD MMM YYYY') : ""}
                                                                                                </span>
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Download : </strong>
                                                                                                <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                                    {item.attachmentName && item.attachmentName ?
                                                                                                    <>
                                                                                                        <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                                        <a href={item.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                                          <i class="fa fa-eye click ml-1"></i>
                                                                                                        </a>
                                                                                                  </>
                                                                                                : null}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal fade bd-example-modal-lg" id="LastDrydockAsbestosFreeDeclaration" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header" style={{ backgroundColor: "#1E3A8A" }}>
                                                                        <h5 className="modal-title" id="exampleModalLabel" style={{ color: "white" }}>Last Drydock Asbestos Free Declaration</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }}>
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <div className="col-lg-12 m-1">
                                                                            <label className="form-label">Last Drydock Asbestos Free Declaration</label><br></br>
                                                                            <div class="input-group">
                                                                                <div class="input-group-prepend">
                                                                                    <span class="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="ldafd"
                                                                                        onChange={e => this.handleInputChange(e)}
                                                                                        onClick={(event) => { event.currentTarget.value = null }}

                                                                                    />
                                                                                    </span>
                                                                                </div>
                                                                                <input type="text" class="form-control" placeholder="No file chosen"
                                                                                    value={this.state.ldafdFilename}

                                                                                />
                                                                                {this.state.ldafdFilename !== "" ?
                                                                                    <div class="input-group-append" style={{ cursor: "pointer" }}>
                                                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.Clearldafd()}></i>
                                                                                    </div>
                                                                                    : null}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-12 m-2">
                                                                            <label className="form-label">Issued Date</label>
                                                                            <div
                                                                                className="input-group add-on date datepicker"
                                                                                data-date-format="yyyy-mm-dd"  >
                                                                                <input
                                                                                    type="text"
                                                                                    value={this.state.shipData.ldafdIssuedDate}
                                                                                    className="form-control date-picker"
                                                                                    placeholder="Issued On"
                                                                                    name="POFromDate" ></input>
                                                                                <DatePicker
                                                                                    onChange={this.handleldafdFromDateChange}
                                                                                    open={this.state.ldafdFromDateOpen}
                                                                                    onClickOutside={this.handleBlur}
                                                                                    showMonthDropdown
                                                                                    showYearDropdown
                                                                                    dropdownMode="select"
                                                                                    popperPlacement="top-end"
                                                                                    className="form-control date-picker w-5 hide-date" />
                                                                                <div
                                                                                    className="input-group-btn calendar-icon"
                                                                                    onClick={this.openldafdFromDatePicker}
                                                                                >
                                                                                    <button className="btn btn-default" style={{ height: "100%" }}>
                                                                                        <i className="fa fa-calendar mt-1"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3" style={{ backgroundColor: "1E3A8A" }} onClick={() => this.updateldafd()}>Update</button>
                                                                        <button type="button" className="btn btn-light text-uppercase txtside-btn txtht-btn mt-3" data-dismiss="modal">Cancel</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.certificateType === "asbestosplan" && <div className={`full-heightpb-4`}>
                                                        <div className="row mt-3">
                                                            <div className="col-lg-12">
                                                                <div className="panel-box">
                                                                    <div className="card MM-card-header" style={{ backgroundColor: "white", marginBottom: 0 }}>
                                                                        <div className="card-body flex">
                                                                            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                                                                Asbestos Management Plan (Applicable for vessel’s built prior to 1st July 2002)
                                                                            </h5>
                                                                            {userrole === Role.staff ?
                                                                                <div className="m-1 flex" onClick={this.NewitemNav} data-toggle="modal" data-target="#AsbestosManagementPlan">
                                                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                                                </div>
                                                                                :
                                                                                ""
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="py-3">
                                                                        <div className="resource-list-auth-date">
                                                                            <div className="row">
                                                                                <div className={"col-sm-12"}>
                                                                                    <div className="row mx-2 my-2">
                                                                                        <div className="col-sm-3">
                                                                                            <span>
                                                                                                <strong>Download : </strong>
                                                                                                <span class="italicFont text-break">  {item.attachmentName ? item.attachmentName : ""}
                                                                                                    {item.attachmentName && item.attachmentName ?
                                                                                                    <>
                                                                                                        <i class="fa fa-download click ml-2" onClick={() => this.downloadDocument(item)}></i>
                                                                                                        <a href={item?.fileUrl} target="_blank" className="link-colors pl-2">
                                                                                                        <i class="fa fa-eye click ml-1"></i>
                                                                                                        </a>
                                                                                                     </>
                                                                                                        : null}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal fade bd-example-modal-lg" id="AsbestosManagementPlan" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header" style={{ backgroundColor: "#1E3A8A" }}>
                                                                        <h5 className="modal-title" id="exampleModalLabel" style={{ color: "white" }}>Asbestos Management Plan</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }}>
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <div className="col-lg-12 m-1">
                                                                            <label className="form-label">Asbestos Management Plan</label><br></br>
                                                                            <div class="input-group">
                                                                                <div class="input-group-prepend">
                                                                                    <span class="input-group-text">Choose file<input type="file" style={{ marginRight: 40 }} id="files" name="amp"
                                                                                        onChange={e => this.handleInputChange(e)}
                                                                                        onClick={(event) => { event.currentTarget.value = null }}
                                                                                    />
                                                                                    </span>
                                                                                </div>
                                                                                <input type="text" class="form-control" placeholder="No file chosen"
                                                                                    value={this.state.ampFilename}
                                                                                />
                                                                                {this.state.ampFilename !== "" ?
                                                                                    <div class="input-group-append" style={{ cursor: "pointer" }}>
                                                                                        <i class="fa fa-times input-group-text" aria-hidden="true" onClick={() => this.Clearamp()}></i>
                                                                                    </div>
                                                                                    : null}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3" style={{ backgroundColor: "1E3A8A" }} onClick={() => this.updateAmp()}>Update</button>
                                                                        <button type="button" className="btn btn-light text-uppercase txtside-btn txtht-btn mt-3" data-dismiss="modal">Cancel</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                </>
                                                )
                                            })
                                            }
                                        </>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

function mapStateToProps(state) {

    return {
        //BY BALU MOORTHI
        CertificateHKC: state.ShipViewReducer.CertificateHKC || {},
        IAPPAttachment: state.MasterScreenReducer.IAPPAttachment,
        AMPAttachment: state.MasterScreenReducer.AMPAttachment,
        ECAttachment: state.MasterScreenReducer.ECAttachment,
        LDSFAAttachment: state.MasterScreenReducer.LDSFAAttachment,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Certificates);
